import * as ctypes from '../../constants/common/ActionTypes';
import * as commonLogic from '../../logic/CommonLogic';
import * as apiWrapper from '../../logic/APIWrapper';
import * as apiWrapperOpenId from '../../logic/APIWrapperOpenId';
import * as authenticator from '../../logic/Authenticator';
import * as cookies from '../../logic/Cookies';
import * as exceptionHandler from '../../logic/ExceptionHandler';

const kubunList = [];
const itemList = [];
const rateList = [];

/**
 * CSVボタン押下時のイベントリスナー
 */
export function clickCsv() {
  // CSV出力を押下時、押下直前に指定されていた検索条件に基づきCSVを作成し、ダウンロードする
  return {
    type: ctypes.CLICK_CSV
  };
}

/**
 * 期間変更時のイベントリスナー
 */
export function clickKikanCal(value, termStart, termEnd) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollLeftMain());
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollLeftKisyu());
  } else {
    cookies.setItem('scrollPosition', -1);
  }

  // 選択した日付
  // 選択した日付(期間)
  return {
    type: ctypes.CHANGE_KIKAN,
    value: value,
    termStart: termStart,
    termEnd: termEnd,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * 納品開始日変更時のイベントリスナー
 */
export function clickKaishibiCal(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll')));
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll_kisyu')));
  } else {
    cookies.setItem('scrollPosition', -1);
  }

  return {
    type: ctypes.CHANGE_KAISHIBI,
    value: value,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * 納品開始日From変更時のイベントリスナー
 */
export function changeKaishibiFrom(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll')));
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll_kisyu')));
  } else {
    cookies.setItem('scrollPosition', -1);
  }

  return {
    type: ctypes.CHANGE_KAISHIBI_FROM,
    value: value,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * 納品開始日To変更時のイベントリスナー
 */
export function changeKaishibiTo(value) {
  // 横スクロールポジションを初期位置に戻しcookieに保存
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll')));
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll_kisyu')));
  } else {
    cookies.setItem('scrollPosition', -1);
  }

  return {
    type: ctypes.CHANGE_KAISHIBI_TO,
    value: value,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * 期間カレンダーオープン
 */
export function openKikan() {
  // 入手したスクロールポジションをcookieに保存
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll')));
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll_kisyu')));
  } else {
    cookies.setItem('scrollPosition', commonLogic.getScrollLeft());
  }

  return {
    type: ctypes.OPEN_KIKAN
  };
}

/**
 * 期間カレンダークローズ
 * @param {*} value
 * @param {*} termStart
 * @param {*} termEnd
 */
export function closeKikan(value, termStart, termEnd) {
  return {
    type: ctypes.CLOSE_KIKAN,
    value: value,
    termStart: termStart,
    termEnd: termEnd,
  };
}

/**
 * 納品開始日カレンダークローズ
 * @param {*} value
 */
export function closeKaishibi(value) {
  return {
    type: ctypes.CLOSE_KAISHIBI,
    value: value
  };
}

/**
 * 期間カレンダー選択
 * @param {*} value
 * @param {*} termStart
 * @param {*} termEnd
 */
export function selectKikan(value, termStart, termEnd) {
  return {
    type: ctypes.SELECT_KIKAN,
    value: value,
    termStart: termStart,
    termEnd: termEnd,
  };
}

/**
 * 納品開始日カレンダー選択
 * @param {*} value
 */
export function selectNohin(value) {
  return {
    type: ctypes.SELECT_NOHIN,
    value: value
  };
}

/**
 * NEWカレンダーを開く
 * @param {*} displayDate
 * @returns
 */
export function openDatePicker(displayDate, isNohinCalendar, viewMode, isFromDatePicker) {
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', -1);
    cookies.setItem('scrollPositionKisyu', -1);
  }

  return {
    type: ctypes.OPEN_DATEPICKER,
    isNohinCalendar: isNohinCalendar,
    viewMode: viewMode,
    isFromDatePicker: isFromDatePicker,
    displayDate: displayDate,
  };
}

/**
 * NEWカレンダー 表示期間を更新する
 * @param {*} newDate
 * @returns
 */
export function updateDisplayDate(newDate) {
  return {
    type: ctypes.UPDATE_DISPLAY_DATE,
    displayDate: newDate,
  };
}

/**
 * NEWカレンダーキャンセル（閉じる）
 * @param {*} value
 * @returns
 */
export function cancelCalendar(value) {
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', -1);
    cookies.setItem('scrollPositionKisyu', -1);
  }
  return {
    type: ctypes.CALENDAR_CANCEL,
    value: value,
  };
}

/**
 * NEWカレンダー表示モード変更
 * @param {*} value
 * @returns
 */
export function changeCalendarViewMode(value) {
  return {
    type: ctypes.CHANGE_CALENDAR_VIEW_MODE,
    value: value,
  };
}

/**
 * 期間を選択する
 * @param {*} term
 * @param {*} displayDate
 * @returns
 */
export function changeKikanTerm(term, termStart, termEnd, displayDate) {
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll')));
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollMaxLeft($('.ledger_sheet_scroll_kisyu')));
  }

  return {
    type: ctypes.UPDATE_KIKAN_TERM,
    term: term,
    termStart: termStart,
    termEnd: termEnd,
    displayDate: displayDate,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * 期間単位（1日/週間/月間/年間）を変更する
 *
 * @param {*} termUnit
 * @param {*} viewMode
 * @param {*} selectedTerm
 * @param {*} selectedTermStart
 * @param {*} selectedTermEnd
 * @returns
 */
export function changeKikanUnit(termUnit, viewMode, selectedTerm, selectedTermStart, selectedTermEnd) {
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollLeftMain());
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollLeftKisyu());
  }
  return {
    type: ctypes.CHANGE_KIKAN_UNIT,
    termUnit: termUnit,
    term: selectedTerm,
    termStart: selectedTermStart,
    termEnd: selectedTermEnd,
    viewMode: viewMode,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
 * グラフの期間単位（日間/週間）を変更する
 * @param {*} termUnit
 * @param {*} viewMode
 * @returns
 */
export function changeGraphKikanUnit(termUnit, viewMode) {
  if (location.pathname.indexOf('K011') !== -1) {
    cookies.setItem('scrollPosition', commonLogic.getScrollLeftMain());
    cookies.setItem('scrollPositionKisyu', commonLogic.getScrollLeftKisyu());
  }
  return {
    type: ctypes.CHANGE_GRAPH_KIKAN_UNIT,
    termUnit: termUnit,
    viewMode: viewMode,
    time: commonLogic.getAPICallPlanTime()
  };
}

/**
* 区分リスト取得
*/
export function onMountedKubun() {
  return (dispatch) => {

    apiWrapper.getShubetsuPartitions((err, allList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: allList });
      } else {
        kubunList.allList = allList;
        dispatch(getPachinkoPartitions(kubunList));
      }
    });
  };
}

/**
* 区分リスト取得(パチンコの区分)
*/
export function getPachinkoPartitions(kubunList) {
  return (dispatch) => {

    apiWrapper.getPachinkoPartitions((err, pachinkoList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: pachinkoList });
      } else {
        kubunList.pachinkoList = pachinkoList;
        dispatch(getSlotPartitions(kubunList));
      }
    });
  };
}

/**
* 区分リスト取得(スロットの区分)
*/
export function getSlotPartitions(kubunList) {
  return (dispatch) => {

    apiWrapper.getSlotPartitions((err, slotList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: slotList });
      } else {
        kubunList.slotList = slotList;
        itemList.kubunList = kubunList;
        dispatch({ type: ctypes.LOADED_KUBUN, itemList: itemList });
      }
    });
  };
}


/**
* 遊技タイプリスト取得
*/
export function onMountedYugiType() {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * 遊技タイプデータ取得
    */
    apiWrapper.getYugiTypeNumbers((err, yugitypeList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: yugitypeList });
      } else {
        itemList.yugitypeList = yugitypeList;
        dispatch({ type: ctypes.LOADED_YUGI_TYPE, itemList: itemList });
      }
    });
  };
}

/**
* 号機リスト取得
*/
export function onMountedGouki() {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * 号機データ取得
    */
    apiWrapper.getUnitNumbers((err, goukiList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: goukiList });
      } else {
        itemList.goukiList = goukiList;
        dispatch({ type: ctypes.LOADED_GOUKI, itemList: itemList });
      }
    });
  };
}


/**
* 種別リスト取得
*/
export function onMountedShubetsu() {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * 区分データ取得
    */
    apiWrapper.getShubetsu((err, shubetsuList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: shubetsuList });
      } else {
        itemList.shubetsuList = shubetsuList;
        dispatch({ type: ctypes.LOADED_SHUBETSU, itemList: itemList });
      }
    });
  };
}


/**
* レートリスト取得
*/
export function onMountedRate() {
  return (dispatch) => {

    /**
    * コントロール部呼び出し
    * スロットレートデータ取得
    */
    apiWrapper.getSlotRates((err, itemList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: itemList });
      } else {
        rateList.slotList = itemList;
        dispatch(getPachinkoRate(rateList));
      }
    });
  };
}

/**
* レートリスト取得
*/
export function getPachinkoRate(rateList) {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * パチンコレートデータ取得
    */
    apiWrapper.getPachinkoRates((err, pachinkoList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: pachinkoList });
      } else {
        rateList.pachinkoList = pachinkoList;
        itemList.rateList = rateList;
        dispatch({ type: ctypes.LOADED_RATE, itemList: itemList });
      }
    });
  };
}

/**
* タイプリスト取得
*/
export function onMountedType() {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * スロットタイプデータ取得
    */
    apiWrapper.getSlotTypes((err, typeList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err });
      } else {
        typeList.slotList = typeList;
        dispatch(getPachinkoTypes(typeList));
      }
    });
  };
}

/**
* タイプリスト取得(パチンコ)
*/
export function getPachinkoTypes(typeList) {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * パチンコタイプデータ取得
    */
    apiWrapper.getPachinkoTypes((err, pachinkoList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: pachinkoList });
      } else {
        typeList.pachinkoList = pachinkoList;
        itemList.typeList = typeList;
        dispatch({ type: ctypes.LOADED_TYPE, itemList: itemList });
      }
    });
  };
}


/**
* メーカーリスト取得
*/
export function onMountedMaker() {
  return (dispatch) => {
    /**
    * コントロール部呼び出し
    * 区分データ取得
    */
    apiWrapper.getBrands((err, makerList) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: makerList });
      } else {
        itemList.makerList = makerList;
        dispatch({ type: ctypes.LOADED_MAKER, itemList: itemList });
      }
    });
  };
}


/**
* 機種名リスト取得(保留)
*/
export function onMountedKishuName(val) {
  return (dispatch) => {

    if (val != null && val == 1) {
      /**
      * コントロール部呼び出し
      * スロット機種データ取得
      */
      apiWrapper.getSlot({}, (err, kishuNameList) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: kishuNameList });
        } else {
          itemList.kishuNameList = kishuNameList;
          dispatch({ type: ctypes.LOADED_KISHUNAME, itemList: itemList });
        }
      });
    } else {
      /**
      * コントロール部呼び出し
      * パチンコ機種データ取得
      */
      apiWrapper.getPachinko({}, (err, kishuNameList) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: kishuNameList });
        } else {
          itemList.kishuNameList = kishuNameList;
          dispatch({ type: ctypes.LOADED_KISHUNAME, itemList: itemList });
        }
      });
    }
  };
}


/**
* カレンダー表示用データ
*/
export function getCalender() {

  return (dispatch, getState) => {
    const state = getState();
    const dispKey = location.pathname; // 画面IDを取得(画面ごとに初期表示が異なるため)

    if (dispKey.indexOf('K002') != -1) {
      /** レート別集計データ期間リスト */
      apiWrapper.getShubetsuTerms(null, (err, term) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
        } else {
          dispatch({ type: ctypes.LOADED_KIKAN, term: term });
        }
      });
    } else if (dispKey.indexOf('K003') !== -1 ||
      dispKey.indexOf('K004') !== -1 ||
      dispKey.indexOf('K005') !== -1 ||
      dispKey.indexOf('K006') !== -1) {

      /** 選択種別データ期間リスト */
      apiWrapper.getShubetsuByIDterms(null, (err, term) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
        } else {
          dispatch({ type: ctypes.LOADED_KIKAN, term: term });
        }
      });
    } else if (dispKey.indexOf('K007') !== -1 ||
      dispKey.indexOf('K011') !== -1 ||
      dispKey.indexOf('K012') !== -1 ||
      dispKey.indexOf('K013') !== -1 ||
      dispKey.indexOf('K014') !== -1 ||
      dispKey.indexOf('K015') !== -1) {

      if (state.pskubun == 0) {
        /** パチンコ機種別集計データ期間リスト */
        apiWrapper.getPachinkoTerms(null, (err, term) => {
          if (err) {
            dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
          } else {
            dispatch({ type: ctypes.LOADED_KIKAN, term: term });
          }
        });
      } else {
        /** スロット機種別集計データ期間リスト */
        apiWrapper.getSlotTerms(null, (err, term) => {
          if (err) {
            dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
          } else {
            dispatch({ type: ctypes.LOADED_KIKAN, term: term });
          }
        });
      }
    } else {

      if (state.pskubun == 0) {
        /** 選択パチンコ機種詳細集計データ期間リスト */
        apiWrapper.getPachinkoByIDTerms(null, (err, term) => {
          if (err) {
            dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
          } else {
            dispatch({ type: ctypes.LOADED_KIKAN, term: term });
          }
        });
      } else {
        /** 選択スロット機種詳細集計データ期間リスト */
        //
        apiWrapper.getSlotByIDTerms(null, (err, term) => {
          if (err) {
            dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
          } else {
            dispatch({ type: ctypes.LOADED_KIKAN, term: term });
          }
        });
      }
    }
  };
}

/**
* 納品開始日初期値取得
*/
export function getLatestDay() {

  return (dispatch, getState) => {
    const state = getState();

    if (state.pskubun == 0) {
      /** パチンコ機種別集計データ期間リスト */
      apiWrapper.getPachinkoNewmodels((err, term) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
        } else {
          dispatch({ type: ctypes.LOADED_KAISHIBI, term: term });
        }
      });
    } else {
      /** スロット機種別集計データ期間リスト */
      apiWrapper.getSlotNewModels((err, term) => {
        if (err) {
          dispatch({ type: ctypes.ERROR_COMMON, error: err, errPara: term });
        } else {
          dispatch({ type: ctypes.LOADED_KAISHIBI, term: term });
        }
      });
    }
  };
}

/**
 * checkContract
 */
export function checkContract(idToken) {

  return (dispatch) => {
    apiWrapperOpenId.checkContract(idToken, (err, result) => {
      if (err) {
        dispatch({ type: ctypes.ERROR_COMMON, error: err });
      } else {
        dispatch({ type: ctypes.USER_NAME, userName: result.cn });
      }
    });
  };
}

/**
 * onScriptError
 */
export function onScriptError() {
  return (dispatch) => {
    dispatch({ type: ctypes.ERROR_COMMON, error: new Error(-1) });
  };
}

/**
 * logout
 */
export function logout() {
  return (dispatch) => {

    // セッション・クッキーの削除
    authenticator.deleteSessionCookie();

    exceptionHandler.cancel();
    // [ポータル]ログアウトAPI（P006）を実行
    location.replace(PORTAL_URL_END_SESSION);
  };
}
